import React from 'react';
import { useHistory } from 'react-router-dom';
import { DELAYED_SCREENING_MESSAGE } from '../NewComponents/DatabaseCard';

interface IEntityDBRowProps {
  transaction?: any;
  getParagraphText: (db: any) => string;
}

const EntityDBRow: React.FC<IEntityDBRowProps> = ({ transaction, getParagraphText }) => {
  const history = useHistory();
  const db = transaction;

  if (!db) return null;

  const entityCount = parseInt(db.nr_people_and_companies, 10) || 0;
  const clearedCount = parseInt(db.nr_cleared, 10) || 0;
  const quarantinedCount = parseInt(db.nr_quarantined, 10) || 0;
  const barredCount = parseInt(db.nr_barred, 10) || 0;
  const highRiskUnclearedCount = parseInt(db.nr_high_risk_uncleared, 10) || 0;
  const screeningRate = entityCount > 0
    ? parseFloat(((highRiskUnclearedCount / entityCount) * 100).toFixed(1))
    : 0;
  const riskBadgeClass = screeningRate < 10 ? 'run-badge completed' : screeningRate <= 35 ? 'run-badge needs-review' : 'run-badge failed';

  return (
    <div className='screening-results-row' onClick={() => history.push(`/database/${db.id}`)}>
      <div className='screening-results-row-default-cell' style={{ flex: '2 0 0' }}>
        <div className='screening-results-row-default-cell-inner' style={{ gap: '10px' }}>
          <div style={{ minWidth: 0 }}>
            <div className='screening-results-row-link-cell-text' style={{ textDecoration: 'none' }} title={db.name}>
              {db.name}
            </div>
            {db.description && (
              <div className='screening-results-row-default-cell-text' style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }} title={db.description}>
                {db.description}
              </div>
            )}
            {db.last_screening_status === 'in-progress' && db.last_screening_delayed_at && (
              <div className='entity-db-row-delayed'>
                {DELAYED_SCREENING_MESSAGE}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>{entityCount.toLocaleString()}</div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>{clearedCount.toLocaleString()}</div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>{(quarantinedCount + barredCount).toLocaleString()}</div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <span className={riskBadgeClass}>{screeningRate.toFixed(1)}%</span>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>{getParagraphText(db)}</div>
        </div>
      </div>
    </div>
  );
};

export default EntityDBRow;
